import { useState } from 'react'
import Permissoes from '../../middleware/Permissoes'
import SubMenuOpcoes from '../SubMenuOpcoes'
import menuOpcoes from '../../interfaces/propsMenuOpcoes'
import '../../styles/menuopcoes.css'

function MenuDocumentosDigitais (props: menuOpcoes) {

    const [subMenu, setSubMenu] = useState(false)

    function exibirSubmenu () {
        setSubMenu (subMenu => !subMenu)
    }

    return (
        <Permissoes permissoes={['master', 'administrativo', 'doc_acesso']}>
            <div>
                <div id = 'menuOpcoes' onClick={exibirSubmenu}>
                    {<img id = 'iconeMenu' src= {props.icone} alt = {props.alt}></img>}
                    <p id = 'tituloMenu'>{props.titulo}</p>
                    <h3>Novo</h3>
                </div>
                <div id = 'submenuOpcoes'>
                    <Permissoes permissoes={['master', 'administrativo', 'doc_contrato']}>
                        {subMenu && <SubMenuOpcoes redirect = {'/contratos'} texto = 'Contratos' />}
                    </Permissoes>
                    <Permissoes permissoes={['master', 'administrativo', 'doc_assinatura']}>
                        {subMenu && <SubMenuOpcoes redirect = {'/documentos-digitais'} texto = 'Solicitar Assinaturas' />}
                    </Permissoes>
                    <Permissoes permissoes={['master', 'doc_solicitacoes']}>
                        {subMenu && <SubMenuOpcoes redirect = {'/documentos-digitais?escritorio=true'} texto = 'Todas as Solicitações' />}
                    </Permissoes>
                    <Permissoes permissoes={['master', 'doc_modelo_contrato']}>
                        {subMenu && <SubMenuOpcoes redirect = {'/modelos-contratos'} texto = 'Modelos de Contratos' />}
                    </Permissoes>
                </div>
            </div>
        </Permissoes>
    )
}

export default MenuDocumentosDigitais